import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  getResponsiveState = new Subject<'pc' | 'tablet' | 'mobile'>();

  constructor() {}
}
